export default __webpack_public_path__ + "static/media/u1.3263b1a1.jpg";